import { createContext, useReducer, useState, useContext } from 'react'

export const ApplicationContext = createContext() 

export const applicationReducer = (state, action) => {
    switch (action.type) {
        case 'SET_APPLICATION':
            return { applications: action.payload }
        case 'CREATE_APPLICATION':
            return { applications: [action.payload, ...state.applications] }
        case 'UPDATE_APPLICATION':
            return {
              ...state,
              applications: state.applications.map(application =>
                application._id === action.payload._id
                  ? action.payload
                  : application
              )
            }
        case 'DELETE_APPLICATION':
            return { applications: state.applications.filter(a => a._id !== action.payload._id) }
        default:
            return state
    }
}

export const ApplicationContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(applicationReducer, { applications: null })
    const [targetApplication, setTargetApplication] = useState()
    return (<ApplicationContext.Provider value={{ ...state, dispatch, targetApplication, setTargetApplication}}>{ children }</ApplicationContext.Provider>)
}

export const useApplicationContext = () => {
    const context = useContext(ApplicationContext)
    if(!context) throw Error('useApplicationContext must be used inside an AuthContextProvider')
    return context
}